import {Decimal} from 'decimal.js';

/**
 * Rewrites a decimal string into its canonical form, so two values that differ only in notation
 * compare as equal. A value the decimal parser rejects is returned unchanged.
 */
export function normalizeDecimalValue(value: string | null) {
  if (value === null) {
    return null;
  }

  try {
    return new Decimal(value).toString();
  } catch {
    return value;
  }
}
